import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { CentroCustoRequest, Response } from './Types';

class CentroCustoController {
  public static async Listar(request: CentroCustoRequest): Promise<Response> {
    try {

      const response = await Api.post('api/centrocusto/Listar', request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(CentroCustoId: number): Promise<Response> {
    try {

      const response = await Api.get(
        `api/centrocusto/ListarUnico/${CentroCustoId}`
      );

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(
    request: CentroCustoRequest
  ): Promise<Response> {
    try {

      const response = await Api.post(`api/centrocusto/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(
    request: CentroCustoRequest
  ): Promise<Response> {
    try {

      const response = await Api.put(`api/centrocusto/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: CentroCustoRequest): Promise<Response> {
    try {

      const response = await Api.put(`api/centrocusto/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default CentroCustoController;
